// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.temp_footer_wrapper {
    width: 100%;
    background: #F8F8F8;
    padding: 40px;
}

.temp_footer_inner {
    width: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    padding: 0 100px;
}

.temp_footer_logo_div {
    width: 200px;
    height: 50px;
}

.temp_footer_logo_div > img {
    width: 100%;
    height: 100%;
}


.temp_footer_links {
    width: 60%;
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
    justify-content: flex-end;
    gap: 50px;
}

.temp_footer_btn {
    color: #000;
font-family: Roboto;
font-size: 18px;
font-style: normal;
font-weight: 500;
line-height: normal;
}









@media screen and (max-width: 1024px) {

    .temp_footer_wrapper {
        padding: 40px 0;
    }
    
    .temp_footer_inner {
        flex-direction: row;
        justify-content: space-between;
        padding: 0 50px;
    }
    
    .temp_footer_logo_div {
        width: 200px;
        height: 50px;
    }
        
    .temp_footer_links {
        width: 60%;
        flex-direction: row;
        gap: 30px;
    }
    
    .temp_footer_btn {
    font-size: 18px;
    }

}











@media screen and (max-width: 800px) {

    .temp_footer_wrapper {
        padding: 30px 0;
    }
    
    .temp_footer_inner {
        flex-direction: row;
        justify-content: space-between;
        padding: 0 30px;
    }
    
    .temp_footer_logo_div {
        width: 200px;
        height: 50px;
    }
        
    .temp_footer_links {
        width: 100%;
        flex-direction: row;
        gap: 20px;
    }
    
    .temp_footer_btn {
    font-size: 18px;
    }

}






@media screen and (max-width: 600px) {

    .temp_footer_wrapper {
        padding: 30px 0;
    }
    
    .temp_footer_inner {
        flex-direction: row;
        justify-content: space-between;
        padding: 0 20px;
    }
    
    .temp_footer_logo_div {
        width: 180px;
        height: 50px;
    }
        
    .temp_footer_links {
        width: 100%;
        flex-direction: row;
        gap: 10px;
    }
    
    .temp_footer_btn {
    font-size: 16px;
    }

}










@media screen and (max-width: 450px) {

    .temp_footer_wrapper {
        padding: 20px 0 40px 0;
    }
    
    .temp_footer_inner {
        flex-direction: column;
        justify-content: space-between;
        padding: 0 20px;
    }
    
    .temp_footer_logo_div {
        width: 180px;
        height: 50px;
    }
        
    .temp_footer_links {
        width: 100%;
        flex-direction: column;
        justify-content: center;
        gap: 10px;
        margin-top: 20px;
    }
    
    .temp_footer_btn {
    font-size: 16px;
    }

}`, "",{"version":3,"sources":["webpack://./src/components/common/tempfooter.css"],"names":[],"mappings":"AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,aAAa;AACjB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,mBAAmB;IACnB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;;AAGA;IACI,UAAU;IACV,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,SAAS;AACb;;AAEA;IACI,WAAW;AACf,mBAAmB;AACnB,eAAe;AACf,kBAAkB;AAClB,gBAAgB;AAChB,mBAAmB;AACnB;;;;;;;;;;AAUA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,8BAA8B;QAC9B,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,SAAS;IACb;;IAEA;IACA,eAAe;IACf;;AAEJ;;;;;;;;;;;;AAYA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,8BAA8B;QAC9B,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,SAAS;IACb;;IAEA;IACA,eAAe;IACf;;AAEJ;;;;;;;AAOA;;IAEI;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;QACnB,8BAA8B;QAC9B,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,mBAAmB;QACnB,SAAS;IACb;;IAEA;IACA,eAAe;IACf;;AAEJ;;;;;;;;;;;AAWA;;IAEI;QACI,sBAAsB;IAC1B;;IAEA;QACI,sBAAsB;QACtB,8BAA8B;QAC9B,eAAe;IACnB;;IAEA;QACI,YAAY;QACZ,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,gBAAgB;IACpB;;IAEA;IACA,eAAe;IACf;;AAEJ","sourcesContent":["@import url(\"https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap\");\n\n.temp_footer_wrapper {\n    width: 100%;\n    background: #F8F8F8;\n    padding: 40px;\n}\n\n.temp_footer_inner {\n    width: 100%;\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 100px;\n}\n\n.temp_footer_logo_div {\n    width: 200px;\n    height: 50px;\n}\n\n.temp_footer_logo_div > img {\n    width: 100%;\n    height: 100%;\n}\n\n\n.temp_footer_links {\n    width: 60%;\n    display: flex;\n    flex-direction: row;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: flex-end;\n    gap: 50px;\n}\n\n.temp_footer_btn {\n    color: #000;\nfont-family: Roboto;\nfont-size: 18px;\nfont-style: normal;\nfont-weight: 500;\nline-height: normal;\n}\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 1024px) {\n\n    .temp_footer_wrapper {\n        padding: 40px 0;\n    }\n    \n    .temp_footer_inner {\n        flex-direction: row;\n        justify-content: space-between;\n        padding: 0 50px;\n    }\n    \n    .temp_footer_logo_div {\n        width: 200px;\n        height: 50px;\n    }\n        \n    .temp_footer_links {\n        width: 60%;\n        flex-direction: row;\n        gap: 30px;\n    }\n    \n    .temp_footer_btn {\n    font-size: 18px;\n    }\n\n}\n\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 800px) {\n\n    .temp_footer_wrapper {\n        padding: 30px 0;\n    }\n    \n    .temp_footer_inner {\n        flex-direction: row;\n        justify-content: space-between;\n        padding: 0 30px;\n    }\n    \n    .temp_footer_logo_div {\n        width: 200px;\n        height: 50px;\n    }\n        \n    .temp_footer_links {\n        width: 100%;\n        flex-direction: row;\n        gap: 20px;\n    }\n    \n    .temp_footer_btn {\n    font-size: 18px;\n    }\n\n}\n\n\n\n\n\n\n@media screen and (max-width: 600px) {\n\n    .temp_footer_wrapper {\n        padding: 30px 0;\n    }\n    \n    .temp_footer_inner {\n        flex-direction: row;\n        justify-content: space-between;\n        padding: 0 20px;\n    }\n    \n    .temp_footer_logo_div {\n        width: 180px;\n        height: 50px;\n    }\n        \n    .temp_footer_links {\n        width: 100%;\n        flex-direction: row;\n        gap: 10px;\n    }\n    \n    .temp_footer_btn {\n    font-size: 16px;\n    }\n\n}\n\n\n\n\n\n\n\n\n\n\n@media screen and (max-width: 450px) {\n\n    .temp_footer_wrapper {\n        padding: 20px 0 40px 0;\n    }\n    \n    .temp_footer_inner {\n        flex-direction: column;\n        justify-content: space-between;\n        padding: 0 20px;\n    }\n    \n    .temp_footer_logo_div {\n        width: 180px;\n        height: 50px;\n    }\n        \n    .temp_footer_links {\n        width: 100%;\n        flex-direction: column;\n        justify-content: center;\n        gap: 10px;\n        margin-top: 20px;\n    }\n    \n    .temp_footer_btn {\n    font-size: 16px;\n    }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
